import type { PixelCrop } from 'react-image-crop'

const BANNER_ASPECT_RATIO = 3
const INITIAL_CROP_SCALE = 0.9

export function initialBannerCrop(mediaWidth: number, mediaHeight: number): PixelCrop {
    const cropWidth = Math.min(mediaWidth, mediaHeight * BANNER_ASPECT_RATIO) * INITIAL_CROP_SCALE
    const cropHeight = cropWidth / BANNER_ASPECT_RATIO

    return {
        unit: 'px',
        width: cropWidth,
        height: cropHeight,
        x: (mediaWidth - cropWidth) / 2,
        y: (mediaHeight - cropHeight) / 2,
    }
}
